import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/vzrokIzlocitve";

export const getEliminationReasonCodeList = createAsyncThunk(
  "eliminationReason/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const eliminationReasonSlice = createSlice({
  name: "eliminationReason",
  initialState: {
    page: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEliminationReasonCodeList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getEliminationReasonCodeList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getEliminationReasonCodeList.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default eliminationReasonSlice.reducer;
